<template>
    <div class="operation-btn">
        <div :class="{'active':item.active}" class="operation-btn-list" v-for="(item,index) in operationAllBtnList" :key='index' @click="selectBtn(item.name, item.active)">
            <div v-if="item.ifShow">
                <a-icon :type="item.icon" />
                <span>{{item.name}}</span>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="tagListBool" footer='' width='440px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>标签</span>
                    <a-icon @click="hideTagBox" class="coordination-search-close" type="close" />
                </div>
                <div class='tag-box'>
                    <div class="new-add-tags">
                        <a-button @click="newTags" class="coordination-search-button" icon="plus">
                        新建标签
                        </a-button>
                    </div>
                    <div class="coordination-search">
                        <a-icon class="coordination-search-icon" type="search" />
                        <a-input @change="queryTagList()" class="coordination-search-input" v-model="filterTagName" placeholder="搜索标签" />
                    </div>
                    <div class="tag-list">
                        <ul>
                            <li v-for="(item,index) in tagListData" :key='index' :style="{'color':item.color}">
                                <a-icon class="tag-icon" type="tag" />
                                <span class="tag-name">{{item.name}}</span>
                                <div class="btn-group">
                                    <a-icon @click="editTag(item.id,item.name)" type="edit" />
                                    <a-icon @click="ifDeleteTag(item.id)" type="delete" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="deleteModal" footer='' width='440px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDelete" type="close" />
                </div>
                <div class="modal-info">
                    <a-icon type="warning" />
                    <div class="modal-content">
                        <div class="modal-tip">您确定要删除吗？</div>
                        <div class="modal-des">删除后数据将无法恢复</div>
                    </div>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelDelete">取消</a-button>
                    <a-button type="primary" @click="sureDelete">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="siteModal" footer='' width='980px'>
            <div class="site-modal modal-public">
                <div class="modal-title">
                    <span>地址</span>
                    <a-icon @click="cancelSite" type="close" />
                </div>
                <div class="modal-info" style="display:flex;flex-direction:column">
                    <div style="height:50px;">
                        <a-button @click="newSiteData" style="height:28px;border:none;background:rgba(158, 172, 196, 0.12);color:rgba(158, 172, 196, 1);line-height:26px;font-size:13px;float:right;" icon="plus">
                           新建数据
                        </a-button>
                    </div>
                    <div v-if="editSiteBool" style="display:flex;padding-bottom:13px;">
                        <div>
                            <a-input v-model="addressInfo.addressee" style="width:120px;color:rgba(158, 172, 196, 1);border:1px solid rgba(158, 172, 196, 0.3)" placeholder="收件人姓名" />
                        </div>
                        <div style="margin:0 12px 0">
                            <a-input v-model="addressInfo.phone" style="width:120px;color:rgba(158, 172, 196, 1);border:1px solid rgba(158, 172, 196, 0.3)" placeholder="收件人电话" />
                        </div>
                        <div>
                            <a-cascader 
                                style="width:250px;color:rgba(158, 172, 196, 1);" 
                                :options="areasData" 
                                placeholder="选择区域" 
                                @change="changeArea" 
                                v-model='selectedAreaCode'
                            />
                        </div>
                        <div style="margin:0 12px 0">
                            <a-input v-model="addressInfo.detailAddress" style="width:240px;color:rgba(158, 172, 196, 1);border:1px solid rgba(158, 172, 196, 0.3)" placeholder="详细地址" />
                        </div>
                        <div style="padding-top:5px;">
                            <a-switch v-model="addressInfo.isDefault" />
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:12px;">设为默认地址</span>
                            <a-icon @click="hideSiteData" style="color:red;cursor:pointer;;margin-left:8px;" type="close" />
                        </div>
                    </div>
                    <div class="site-list">
                        <ul>
                            <li v-for="(item,index) in siteListData" :key='index'>
                                <span class="name">{{item.addressee}}</span>
                                <span class="phone">{{item.phone}}</span>
                                <span class="site">{{item.address}}</span>
                                <span class="default-site">{{item.isDefault}}</span>
                                <div class="edit-btn">
                                    <a-icon @click="editSite(item.id)" type="edit" />
                                    <a-icon @click="deleteSite(item.id)" type="delete" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelSite">取消</a-button>
                    <a-button type="primary" @click="sureSite">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="contractModal" footer='' width='980px'>
            <div class="contract-modal modal-public">
                <div class="modal-title">
                    <span>合约补充协议</span>
                    <a-icon @click="cancelContract" type="close" />
                </div>
                <div class="modal-info" style="display:flex;flex-direction:column;">
                    <div style="height:50px;">
                        <a-button @click="newAgreementOperate" style="height:28px;border:none;background:rgba(158, 172, 196, 0.12);color:rgba(158, 172, 196, 1);line-height:26px;font-size:13px;float:right;" icon="plus">
                           新建协议
                        </a-button>
                    </div>
                    <div style="height:140px;" v-if="newAgreementState">
                        <div>
                            <a-select placeholder='请选择' v-model="agreementInfo.status" style="width: 266px;border:1px solid rgba(158, 172, 196, 0.3);margin-right:24px;">
                                <a-select-option value="1">
                                    待生效
                                </a-select-option>
                                <a-select-option value="2">
                                    已生效
                                </a-select-option>
                            </a-select>
                            <!-- <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-right:8px;">低消</span>
                            <a-input-number v-model="agreementInfo.lowElimination" style="border:1px solid rgba(158, 172, 196, 0.3)" :min="1" />
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:8px;">元</span> -->
                        </div>
                        <a-input v-model="agreementInfo.content" placeholder="协议名称" style="border:1px solid rgba(158, 172, 196, 0.3);margin-top:12px;color:rgba(158, 172, 196, 1);" />
                        <a-upload
                            :multiple="true"
                            :customRequest="customRequest2"
                        >
                            <div>
                                <a-button style="color:rgba(158, 172, 196, 1);background:rgba(158, 172, 196, 0.12);margin-top:12px;border:none;"> <a-icon type="upload" />添加附件</a-button>
                            </div>
                        </a-upload>

                    </div>
                    <div style="flex:1;overflow-y:auto;border-top:1px solid rgba(229, 229, 229, 1)">
                        <ul>
                            <li class="contract-list" v-for="(item,index) in agreementListData" :key='index'>
                                <div>
                                    <span class="date">{{item.createTime}}</span>
                                    <span class="state">{{item.status==1?'待生效':'已生效'}}</span>
                                    <!-- <span class="money">￥{{item.lowElimination}}元</span> -->
                                    <div class="edit-btn">
                                        <a-icon @click="editAttachment(item)" type="edit" />
                                        <a-icon @click="deleteAttachment(item.id)" type="delete" />
                                    </div>
                                </div>
                                <div class="des">{{item.content}}</div>
                                <div class="enclosure" v-if="item.attachmentName!=null">
                                    <a-icon class="file-icon" type="file" />
                                    <span class="name">{{item.attachmentName}}</span>
                                    <div class="enclosure-btn">
                                        <a-icon @click="downloadAttachment(item.attachmentUrl)" type="download" />
                                        <a-icon @click="deleteEnclosureOperate(item.id)" type="delete" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelContract">取消</a-button>
                    <a-button type="primary" @click="sureContract">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="customerModal" footer='' width='980px'>
            <div class="customer-modal modal-public">
                <div class="modal-title">
                    <span>客户实名认证</span>
                    <a-icon @click="cancelCustomer" type="close" />
                </div>
                <div class="modal-info">
                    <a-row class="customer-list">
                        <a-col :span="12">
                            <div class="list-item">
                                <span>认证类型：</span>
                                <span>{{customerInfoData.type==1?'个人':'企业'}}</span>
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <div class="list-item">
                                <span>状态：</span>
                                <a-select style="width: 120px;border:1px solid rgba(158, 172, 196, 0.3)" @change="changeExamineState" v-model="customerInfoData.status">
                                    <a-select-option :value="0">
                                        未认证
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        待审核
                                    </a-select-option>
                                    <a-select-option :value="2">
                                        待完善
                                    </a-select-option>
                                    <a-select-option :value="3">
                                        审核通过
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="customer-list">
                        <a-col :span="12">
                            <div class="list-item">
                                <span>企业名称：</span>
                                <span>{{customerInfoData.enterpriseName}}</span>
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <div class="list-item">
                                <span>组织代码：</span>
                                <span>{{customerInfoData.unifiedSocialCreditCode}}</span>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="customer-list">
                        <a-col :span="12">
                            <div class="list-item">
                                <span>姓名：</span>
                                <span>{{customerInfoData.userName}}</span>
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <div class="list-item">
                                <span>身份证号：</span>
                                <span>{{customerInfoData.identityCardNumber}}</span>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="customer-list">
                        <a-col :span="12">
                            <div class="list-item">
                                <span>提交时间：</span>
                                <span>{{customerInfoData.createTime}}</span>
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <div class="list-item">
                                <span>修改时间：</span>
                                <span>{{customerInfoData.updateTime}}</span>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="customer-list">
                        <a-col :span="12">
                            <div class="list-item">
                                <span style="float:left;">营业执照：</span>
                                <img :src="customerInfoData.businessLicense" alt="">
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <div class="list-item">
                                <span style="float:left;">身份证：</span>
                                <img :src="customerInfoData.identityCard" alt="">
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelCustomer">取消</a-button>
                    <a-button type="primary" @click="sureCustomer">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="providerModal" footer='' width='980px'>
            <div class="provider-modal modal-public">
                <div class="modal-title">
                    <span>结算价</span>
                    <a-icon @click="cancelProvider" type="close" />
                </div>
                <div class="modal-info">
                    <a-table :data-source="settlementPriceList" :pagination='false' :scroll="{ y: 480 }" :rowKey="record=>record.id" >
                        <a-table-column key="commodityName" title="商品名称" data-index="commodityName" />
                        <a-table-column key="description" title="规格" data-index="description" />
                        <a-table-column key="appName" title="应用名称" data-index="appName" />
                        <a-table-column key="unitPrice" title="单价" data-index="unitPrice" />
                        <a-table-column key="settlementPrice" title="结算价" data-index="settlementPrice">
                            <template slot-scope="text, record">
                                <div>
                                    <span @click="showSettlementPriceModal(record.specificationsId, record.settlementPrice)" style="color:#1890ff;cursor:pointer;">{{record.settlementPrice}}</span>
                                </div>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelProvider">取消</a-button>
                    <a-button type="primary" @click="sureProvider">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteTagModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteTag" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个标签？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteTag">取消</a-button>
                        <a-button type="primary" @click="sureDeleteTag">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="newTagModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>新增标签</span>
                    <a-icon @click="cancelNewTag" type="close" />
                </div>
                <div class="add-data" style="padding-right:24px;padding-top:30px">
                    <a-input v-model="tagName" placeholder="请输入标签名" />
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelNewTag">取消</a-button>
                        <a-button type="primary" @click="sureNewTag">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="goodsSpecificationsModal" :closable='false' footer='' width='980px'>
            <div class="goods-specificationsModal-modal">
                <div class="add-title">
                    <span>商品规格</span>
                    <a-icon @click="cancelGoods" type="close" />
                </div>
                <div class="new-specificationsModal">
                    <a-button icon="plus" @click="newSpecifications">
                    新建规格
                    </a-button>
                </div>
                <div class="dimension-box">
                    <div class="dimension-list" v-for="(item,index) in allDimensionListData" :key='index'>
                        <a-row class="dimension-row">
                            <a-col :span="5">
                                <span>维度ID：</span>
                                <span>{{item.id}}</span>
                            </a-col>
                            <a-col :span="5">
                                <span>维度名称：</span>
                                <span>{{item.name}}</span>
                            </a-col>
                            <a-col :span="5">
                                <span>维度排序：</span>
                                <span>{{item.sort}}</span>
                            </a-col>
                            <a-col :span="5">
                                <span>维度类型：</span>
                                <span>{{item.type}}</span>
                            </a-col>
                            <a-col :span="4">
                                <a-icon @click="deleteDimension(item.id)" type="delete" />
                                <a-icon @click="editDimension(item.id)" type="edit" />
                            </a-col>
                        </a-row>
                        <div class="dimension-content">
                            <div class="dimension-head">
                                <a-row>
                                    <a-col :span="2">
                                        规格名称
                                    </a-col>
                                    <a-col :span="2">
                                        规格排序
                                    </a-col>
                                    <a-col :span="4">
                                        <div>单价(unit_price)</div>
                                    </a-col>
                                    <a-col :span="4">
                                        <div>成本价(cost_price)</div>
                                    </a-col>
                                    <a-col :span="4">
                                        <div>结算价(settlement_price)</div>
                                    </a-col>
                                    <a-col :span="3">
                                        <div>商品数量(quantity)</div>
                                    </a-col>
                                    <a-col :span="3">
                                        <div>折扣系数(discount)</div>
                                    </a-col>
                                    <a-col :span="2">
                                        状态
                                    </a-col>
                                </a-row>
                            </div>
                            <div class="dimension-body" v-for="(item1,index1) in item.specificationsList" :key='index1'>
                                <a-row style="border-bottom:1px solid #e8ebee;padding:10px 0">
                                    <a-col :span="2">
                                        {{item1.name}}
                                    </a-col>
                                    <a-col :span="2">
                                        {{item1.sort}}
                                    </a-col>
                                    <a-col :span="4">
                                        {{item1.unitPrice}}
                                    </a-col>
                                    <a-col :span="4">
                                        {{item1.costPrice}}
                                    </a-col>
                                    <a-col :span="4">
                                        {{item1.settlementPrice}}
                                    </a-col>
                                    <a-col :span="3">
                                        {{item1.quantity}}
                                    </a-col>
                                    <a-col :span="3">
                                        {{item1.discount}}
                                    </a-col>
                                    <a-col :span="2">
                                        {{item1.statusName}}
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelGoods">取消</a-button>
                        <a-button type="primary" @click="sureGoods">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="newGoodsModal" :closable='false' footer='' width='980px'>
            <div class="new-goods-modal">
                <div class="add-title">
                    <span>新增</span>
                    <a-icon @click="cancelSpecifications" type="close" />
                </div>
                <div class="dimension-box">
                    <div class="dimension-list">
                        <a-row class="dimension-row">
                            <a-col :span="8">
                                <span>维度名称：</span>
                                <a-input v-model="newDimensionObj.name" class="dimension-name" placeholder="维度名称" />
                            </a-col>
                            <a-col :span="8">
                                <span>维度排序：</span>
                                <a-input-number v-model="newDimensionObj.orderBy" />
                            </a-col>
                            <a-col :span="8">
                                <span>维度类型：</span>
                                <a-select style="width: 200px;border:1px solid rgba(229, 229, 229, 1)" v-model="newDimensionObj.type">
                                    <a-select-option :value="Number(item.value)" v-for="(item,index) in dimensionTypeList" :key='index'>
                                        {{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-col>
                        </a-row>
                        <div class="specifications-box">
                            <a-row class="specifications-head">
                                <a-col :span="4">
                                    规格名称
                                </a-col>
                                <a-col :span="2">
                                    规格排序
                                </a-col>
                                <a-col :span="2">
                                    单价
                                </a-col>
                                <a-col :span="3">
                                    成本价
                                </a-col>
                                <a-col :span="3">
                                    结算价
                                </a-col>
                                <a-col :span="2">
                                    商品数量
                                </a-col>
                                <a-col :span="2">
                                    折扣系数
                                </a-col>
                                <a-col :span="3">
                                    状态
                                </a-col>
                                <a-col :span="3">
                                    操作
                                </a-col>
                            </a-row>
                            <a-row class="specifications-list" v-for="(item,index) in specificationsData" :key='index'>
                                <a-col :span="4">
                                   <a-input v-model="item.name" class="specifications-name specifications-col-3" placeholder="请输入" />
                                </a-col>
                                <a-col :span="2">
                                    <a-input-number v-model="item.sort" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                 <a-col :span="2">
                                    <a-input-number v-model="item.unitPrice" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                 <a-col :span="3">
                                    <a-input-number v-model="item.costPrice" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                 <a-col :span="3">
                                    <a-input-number v-model="item.settlementPrice" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                <a-col :span="2">
                                    <a-input-number v-model="item.quantity" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                <a-col :span="2">
                                    <a-input-number v-model="item.discount" class="specifications-col-2" placeholder="值" />
                                </a-col>
                                <a-col :span="3">
                                    <a-select v-model="item.status" class="specifications-col-3" style="width: 90px;border:1px solid rgba(229, 229, 229, 1)" placeholder="请选择">
                                        <a-select-option :value="Number(item1.value)" v-for="(item1, index1) in specificationsStatusList" :key='index1'>
                                            {{item1.name}}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="3">
                                    <a-icon @click="deleteSpecifications(index, item.id)" type="delete" />
                                </a-col>
                            </a-row>
                            <div class="add-item-list">
                                <a-button @click="addItemList" type="primary">
                                新增
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelSpecifications">取消</a-button>
                        <a-button type="primary" @click="sureSpecifications">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteDimensionModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteDimension" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个维度？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteDimension">取消</a-button>
                        <a-button type="primary" @click="sureDeleteDimension">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteSpecificationsModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteSpecifications" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个规格？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteSpecifications">取消</a-button>
                        <a-button type="primary" @click="sureDeleteSpecifications">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteSiteModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteSite" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个地址吗？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteSite">取消</a-button>
                        <a-button type="primary" @click="sureDeleteSite">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="changePriceModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>修改结算价</span>
                    <a-icon @click="cancelChangePrice" type="close" />
                </div>
                <div class="add-data">
                    <a-input-number style="width:150px" v-model="priceData"/>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelChangePrice">取消</a-button>
                        <a-button type="primary" @click="sureChangePrice">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteAgreementModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteAgreement" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个协议吗？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteAgreement">取消</a-button>
                        <a-button type="primary" @click="sureDeleteAgreement">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteEnclosureModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteEnclosure" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个附件吗？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteEnclosure">取消</a-button>
                        <a-button type="primary" @click="sureDeleteEnclosure">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="reducePriceModal" :closable='false' footer='' width='980px'>
            <div class="bill-reduction-modal">
                <div class="reduction-title">
                    <span>账单减免</span>
                    <a-icon @click="cancelReducePrice" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="new-reduction">
                        <a-button @click="newReduction" type="primary" icon="plus">
                        新建减免
                        </a-button>
                    </div>
                    <div>
                        <a-table rowKey="content" :data-source="reductionData" :pagination='false' :scroll="{ y: 340 }">
                            <a-table-column key="content" title="内容" data-index="content" />
                            <a-table-column key="remark" title="备注" data-index="remark" />
                            <a-table-column key="createTime" title="操作时间" data-index="createTime" />
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelReducePrice">取消</a-button>
                        <a-button type="primary" @click="sureReducePrice">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addReductionModal" :closable='false' footer='' width='980px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>新增减免</span>
                    <a-icon @click="cancelAddReduction" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>减免金额：</span>
                        <a-input-number v-model="reductionMoney" class="reduction-input" placeholder="输入内容" />
                    </div>
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea v-model="reductionRemark" class="reduction-input" placeholder="输入备注" :rows="4" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddReduction">取消</a-button>
                        <a-button type="primary" @click="sureAddReduction">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="payDateModal" :closable='false' footer='' width='980px'>
            <div class="bill-reduction-modal">
                <div class="reduction-title">
                    <span>应付日期</span>
                    <a-icon @click="cancelPayDate" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="new-reduction">
                        <a-button @click="changePayDate" type="primary" icon="plus">
                        修改日期
                        </a-button>
                    </div>
                    <div>
                        <a-table rowKey="content" :data-source="payData" :pagination='false' :scroll="{ y: 340 }">
                            <a-table-column key="content" title="内容" data-index="content" />
                            <a-table-column key="remark" title="备注" data-index="remark" />
                            <a-table-column key="createTime" title="操作时间" data-index="createTime" />
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelPayDate">取消</a-button>
                        <a-button type="primary" @click="surePayDate">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="changePayDateModal" :closable='false' footer='' width='980px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>修改日期</span>
                    <a-icon @click="cancelChangePayDate" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>操作时间：</span>
                        <a-date-picker format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" v-model="operationDate" class="date-reduction" />
                    </div>
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea class="reduction-input" v-model="timeRemark" placeholder="输入备注" :rows="4" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelChangePayDate">取消</a-button>
                        <a-button type="primary" @click="sureChangePayDate">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="extraBillModal" :closable='false' footer='' width='980px'>
            <div class="bill-reduction-modal">
                <div class="reduction-title">
                    <span>附加</span>
                    <a-icon @click="cancelExtraBill" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="new-reduction">
                        <a-button @click="newExtraBill" type="primary" icon="plus">
                        新建附加
                        </a-button>
                    </div>
                    <div>
                        <a-table rowKey="content" :data-source="attachmentData" :pagination='false' :scroll="{ y: 340 }">
                            <a-table-column key="content" title="内容" data-index="content" />
                            <a-table-column key="remark" title="备注" data-index="remark" />
                            <a-table-column key="createTime" title="操作时间" data-index="createTime" />
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelExtraBill">取消</a-button>
                        <a-button type="primary" @click="sureExtraBill">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addExtraBillModal" :closable='false' footer='' width='980px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>新增附加</span>
                    <a-icon @click="cancelAddExtraBill" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>附加金额：</span>
                        <a-input-number v-model="extraMoney" class="reduction-input" placeholder="输入备注" />
                    </div>
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea v-model="extraRemark" class="reduction-input" placeholder="输入备注" :rows="4" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddExtraBill">取消</a-button>
                        <a-button type="primary" @click="sureAddExtraBill">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="badBillModal" :closable='false' footer='' width='980px'>
            <div class="bill-reduction-modal">
                <div class="reduction-title">
                    <span>坏账</span>
                    <a-icon @click="cancelBadBill" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="new-reduction">
                        <a-button @click="newBadBill" type="primary" icon="plus">
                        新建坏账
                        </a-button>
                    </div>
                    <div>
                        <a-table rowKey="content" :data-source="badBillData" :pagination='false' :scroll="{ y: 340 }">
                            <a-table-column key="content" title="内容" data-index="content" />
                            <a-table-column key="remark" title="备注" data-index="remark" />
                            <a-table-column key="createTime" title="操作时间" data-index="createTime" />
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelBadBill">取消</a-button>
                        <a-button type="primary" @click="sureBadBill">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addBadBillModal" :closable='false' footer='' width='980px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>新增坏账</span>
                    <a-icon @click="cancelAddBadBill" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>新增：</span>
                        <a-input-number class="reduction-input" v-model="badBillPrice" placeholder="坏账金额" />
                    </div>
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea class="reduction-input" v-model="badBillRemark" placeholder="输入备注" :rows="4" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddBadBill">取消</a-button>
                        <a-button type="primary" @click="sureAddBadBill">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="orderReductionModal" :closable='false' footer='' width='980px'>
            <div class="bill-reduction-modal">
                <div class="reduction-title">
                    <span>订单减免</span>
                    <a-icon @click="cancelOrderReduction" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="new-reduction">
                        <a-button @click="newOrderReduction" type="primary" icon="plus">
                        新建减免
                        </a-button>
                    </div>
                    <div>
                        <a-table rowKey="content" :data-source="orderReductionData" :pagination='false' :scroll="{ y: 340 }">
                            <a-table-column key="content" title="内容" data-index="content" />
                            <a-table-column key="remark" title="备注" data-index="remark" />
                            <a-table-column key="createTime" title="操作时间" data-index="createTime" />
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelOrderReduction">取消</a-button>
                        <a-button type="primary" @click="sureOrderReduction">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addOrderReductionModal" :closable='false' footer='' width='980px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>新增减免</span>
                    <a-icon @click="cancelAddOrderReduction" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>减免金额：</span>
                        <a-input-number v-model="orderReductionMoney" class="reduction-input" placeholder="输入内容" />
                    </div>
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea v-model="orderReductionRemark" class="reduction-input" placeholder="输入备注" :rows="4" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddOrderReduction">取消</a-button>
                        <a-button type="primary" @click="sureAddOrderReduction">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="effectiveModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>生效</span>
                    <a-icon @click="cancelEffective" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>确定要直接生效？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelEffective">取消</a-button>
                        <a-button type="primary" @click="sureEffective">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="selectContractModal" :closable='false' footer='' width='480px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>选择合约</span>
                    <a-icon @click="cancelSelectContract" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>选择合约：</span>
                        <a-select placeholder='请选择' v-model="contractId" style="width: 280px;border:1px solid rgba(158, 172, 196, 0.3)">
                            <a-select-option v-for="(item, index) in contractSelectList" :key='index' :value="item.value">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelSelectContract">取消</a-button>
                        <a-button type="primary" @click="sureSelectContract">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="chargeModal" :closable='false' footer='' width='480px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>充值</span>
                    <a-icon @click="cancelCharge" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>充值：</span>
                        <a-input-number v-model="rechargeAmount" placeholder="输入充值金额" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelCharge">取消</a-button>
                        <a-button type="primary" @click="sureCharge">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="toVoidModal" :closable='false' footer='' width='480px'>
            <div class="add-reduction-modal">
                <div class="reduction-title">
                    <span>资源包停用</span>
                    <a-icon @click="cancelVoid" type="close" />
                </div>
                <div class="reduction-data">
                    <div class="reduction-item">
                        <span>备注：</span>
                        <a-textarea
                            v-model.trim="voidContent"
                            placeholder="请输入内容"
                            style="height:80px;resize: none"
                        />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelVoid">取消</a-button>
                        <a-button type="primary" @click="sureVoid">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="reconciliationModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>对账</span>
                    <a-icon @click="cancelReconciliation" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>修改账单状态为待支付？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelReconciliation">取消</a-button>
                        <a-button type="primary" @click="sureReconciliation">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="numberManageModal" :closable='false' footer='' width='1020px'>
            <div class="number-manage-modal">
                <div class="add-title">
                    <span>号码管理</span>
                    <a-icon @click="cancelManageNumber" type="close" />
                </div>
                <div class="number-manage-data">
                    <div class="input-add-btn">
                        <a-button type="primary" icon="plus" @click="addBatch">
                        批量导入
                        </a-button>
                        <a-button type="primary" icon="plus" @click="addSingle">
                        单个新增
                        </a-button>
                    </div>
                    <a-row class="filter-condition">
                        <a-col :span="6">
                            <span>号码：</span>
                            <a-input style="width: 150px;" v-model="searchNum" @input='inputChange()' placeholder="搜索号码" />
                        </a-col>
                        <a-col :span="6">
                            <span>有效状态：</span>
                            <a-select style="width: 150px;border:1px solid #d9d9d9" placeholder='请选择' @change="changeStatus" v-model="currentStatus">
                                <a-select-option value="">
                                    请选择
                                </a-select-option>
                                <a-select-option value="1">
                                    启用
                                </a-select-option>
                                <a-select-option value="2">
                                    停用
                                </a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>
                    <div class="account-table">
                        <a-table :data-source="numberData1" :pagination='false' :scroll="{ y: 240 }" :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange2 }" :rowKey="(record,index)=>{return record.id}">
                            <a-table-column key="number" title="号码" data-index="number">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.number}}</span>
                                    <a-icon style="cursor:pointer;color:#63e8ff;font-size:14px" @click="changeNumber( record.id, record.number)" type="edit" />
                                </template>
                            </a-table-column>
                            <a-table-column key="status" title="有效状态" data-index="status">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.status}}</span>
                                    <a-icon style="cursor:pointer;color:#63e8ff;font-size:14px" @click="changeListStatus( record.id, record.status)" type="edit" />
                                </template>
                            </a-table-column>
                            <a-table-column key="numberUser" title="使用者" data-index="numberUser">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.numberUser}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="remark" title="备注" data-index="remark">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.remark}}</span>
                                    <a-icon style="cursor:pointer;color:#63e8ff;font-size:14px" @click="changeRemark( record.id, record.remark)" type="edit" />
                                </template>
                            </a-table-column>
                            <a-table-column key="id" title="操作" data-index="id">
                                <template slot-scope="text, record">
                                    <a-icon style="cursor:pointer;color:#63e8ff;font-size:14px" @click="deleteBatch(record.id)" type="delete" />
                                </template>
                            </a-table-column>
                        </a-table>
                        <div>
                            <span style="float:left;margin-top:18px">共{{ total }}条</span>
                            <a-pagination 
                                style="float:right;margin-top:12px"
                                v-model="currentPage"
                                :page-size-options="pageSizeOptions"
                                :total="total"
                                show-size-changer
                                :page-size="pageSize"
                                @change="pageChange"
                                @showSizeChange="onShowSizeChange"
                            >
                                <template slot="buildOptionText" slot-scope="props">
                                    <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                                </template>
                            </a-pagination>
                        </div>
                        
                    </div>
                    <div class="batch-operate">
                        <!-- <a-button type="primary">
                        批量修改
                        </a-button>
                        <a-button type="primary" @click="deleteBatch">
                        批量删除
                        </a-button> -->
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelManageNumber">取消</a-button>
                        <a-button type="primary" @click="sureManageNumber">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="newAddModal" :closable='false' footer='' width='1020px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>新增</span>
                    <a-icon @click="cancelAddList" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="8">
                            <span>号码：</span>
                            <a-input v-model="number1" style="width:150px;" placeholder="号码" />
                        </a-col>
                        <a-col :span="8">
                            <span>有效状态：</span>
                            <div style="display:inline-block;border:1px solid #d9d9d9">
                                <a-select style="width: 150px;" placeholder='请选择' v-model="status1">
                                    <a-select-option value="1">
                                        启用
                                    </a-select-option>
                                    <a-select-option value="2">
                                        停用
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                        <a-col :span="8">
                            <span>备注：</span>
                            <a-input v-model="numberRemark" style="width:150px;" placeholder="备注" />
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddList">取消</a-button>
                        <a-button type="primary" @click="sureAddList">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="normalModal" title="批量新增" footer='' width='600px'>
            <div class="normal-modal modal-public">
                <a-divider class="divider1" type="horizontal" />
                <div class="tab-normal">
                    <div>
                        <span style="color:rgba(80, 80, 80, 1);font-size:14px">*为保证数据导入顺利，请先</span>
                        <a-button @click="downloadTemplate" icon="download" style="margin-left:8px">
                        下载模板
                        </a-button>
                    </div>
                    <div style="min-height:166px;margin-top:24px">
                        <a-upload-dragger
                            key={Math.random()}
                            name="file"
                            :multiple="false"
                            :customRequest="customRequest1"
                            @change="onUpload"
                            ref="pathClear"
                        >
                            <p class="ant-upload-drag-icon">
                            <a-icon type="upload" />
                            </p>
                            <p class="ant-upload-text">
                            点击或将文件拖拽到这里上传
                            </p>
                            <p class="ant-upload-hint">
                            支持扩展名：.xls .xlsx
                            </p>
                        </a-upload-dragger>
                    </div>
                    <div style="margin-top:16px;color:rgba(153, 153, 153, 1);font-size:14px">上传的 Excel 表符合以下规范::</div>
                    <div style="color:rgba(80, 80, 80, 1);margin-top:8px;font-size:12px">文件大小不超过20MB<br>仅支持 (*.xls 和 *.xlsx)文件<br>请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入</div>
                </div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelNormal">取消</a-button>
                    <a-button type="primary" @click="sureNormal">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteModal2" footer='' width='480px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDelete" type="close" />
                </div>
                <div class="modal-info">
                    <a-icon type="warning" />
                    <div class="modal-content">
                        <div class="modal-tip">您确定要删除吗？</div>
                        <div class="modal-des">删除后数据将无法恢复</div>
                    </div>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelDeleteItem">取消</a-button>
                    <a-button type="primary" @click="sureDeleteItem">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchChangeModal" :closable='false' footer='' width='650px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>批量修改</span>
                    <a-icon @click="cancelBatchChange" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="12">
                            <span>权限：</span>
                            <div style="display:inline-block;border:1px solid #d9d9d9;">
                                <a-select style="width: 200px" placeholder='请选择' @change="jurisdictionChange">
                                    <a-select-option value="jack">
                                        Jack
                                    </a-select-option>
                                    <a-select-option value="lucy">
                                        Lucy
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        yiminghe
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                        <a-col :span="12">
                            <span>有效状态：</span>
                            <div style="display:inline-block;border:1px solid #d9d9d9">
                                <a-select style="width: 200px;" placeholder='请选择' @change="jurisdictionChange">
                                    <a-select-option value="jack">
                                        Jack
                                    </a-select-option>
                                    <a-select-option value="lucy">
                                        Lucy
                                    </a-select-option>
                                    <a-select-option value="Yiminghe">
                                        yiminghe
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelBatchChange">取消</a-button>
                        <a-button type="primary" @click="sureBatchChange">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="editNumberModal" :closable='false' footer='' width='600px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>修改</span>
                    <a-icon @click="cancelEditNumber" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="24">
                            <span>号码：</span>
                            <a-input v-model="number2" style="width:200px;" placeholder="号码" />
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelEditNumber">取消</a-button>
                        <a-button type="primary" @click="sureEditNumber">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="editIsSharedModal" :closable='false' footer='' width='600px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>修改</span>
                    <a-icon @click="cancelEditIsShared" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="24">
                            <span>权限：</span>
                            <div style="display:inline-block;border:1px solid #d9d9d9;">
                                <a-select style="width: 200px" placeholder='请选择' v-model="isShared2">
                                    <a-select-option value="1">
                                        共享
                                    </a-select-option>
                                    <a-select-option value="0">
                                        独有
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelEditIsShared">取消</a-button>
                        <a-button type="primary" @click="sureEditIsShared">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="editStatusModal" :closable='false' footer='' width='600px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>修改</span>
                    <a-icon @click="cancelEditStatus" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="24">
                            <span>有效状态：</span>
                            <div style="display:inline-block;border:1px solid #d9d9d9;">
                                <a-select style="width: 200px" placeholder='请选择' v-model="status2">
                                    <a-select-option value="1">
                                        启用
                                    </a-select-option>
                                    <a-select-option value="2">
                                        停用
                                    </a-select-option>
                                </a-select>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelEditStatus">取消</a-button>
                        <a-button type="primary" @click="sureEditStatus">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="editRemarkModal" :closable='false' footer='' width='600px'>
            <div class="new-add-modal">
                <div class="add-title">
                    <span>修改</span>
                    <a-icon @click="cancelEditRemark" type="close" />
                </div>
                <div class="add-data-list">
                    <a-row>
                        <a-col :span="24">
                            <span>备注：</span>
                            <a-input v-model="editRemarkContent" style="width:200px;" placeholder="备注" />
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelEditRemark">取消</a-button>
                        <a-button type="primary" @click="sureEditRemark">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="middleUserModal" :closable='false' footer='' width='1020px'>
            <div class="number-manage-modal">
                <div class="add-title">
                    <span>中台用户列表</span>
                    <a-icon @click="cancelMiddleUser" type="close" />
                </div>
                <div class="number-manage-data">
                    <a-row class="filter-condition">
                        <a-col :span="6">
                            <span>号码：</span>
                            <a-input style="width: 150px;" v-model="middleUserName" @input='inputMiddleChange()' placeholder="名称" />
                        </a-col>
                    </a-row>
                    <div class="account-table">
                        <a-table :data-source="middleUserList" :pagination='false' :scroll="{ y: 240 }" :row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange3  }" :rowKey="(record,index)=>{return record.id}">
                            <a-table-column key="enterpriseName" title="公司名称" data-index="enterpriseName">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.enterpriseName}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="name" title="姓名" data-index="name">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.name}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="phone" title="手机号" data-index="phone">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.phone}}</span>
                                </template>
                            </a-table-column>
                        </a-table>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelMiddleUser">取消</a-button>
                        <a-button type="primary" @click="sureMiddleUser">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="callNumberModal" :closable='false' footer='' width='1020px'>
            <div class="number-manage-modal">
                <div class="add-title">
                    <span>号码管理</span>
                    <a-icon @click="cancelCallNumber" style="float:right" type="close" />
                    <span @click="goLink" style="float:right;display: inline-block;width:56px;height:28px;line-height:28px;text-align: center;font-size:13px;font-weight:normal;background:rgba(58, 220, 255, 1);color:#fff;margin-right:20px;margin-top:-5px;cursor:pointer;">外链</span>
                </div>
                <div class="number-manage-data">
                    <a-row class="filter-condition" style="margin-top:0">
                        <a-col :span="8">
                            <span>搜索号码：</span>
                            <a-input style="width: 220px;" v-model="numberKey" placeholder="搜索号码" />
                        </a-col>
                        <a-col :span="12">
                            <span>分配时间：</span>
                            <a-range-picker valueFormat="YYYY-MM-DD"  v-model="allocateTime" style="width:300px" format="YYYY-MM-DD" />

                        </a-col>
                        <a-col :span="4">
                            <span @click="queryNumberList" style="float:right;display: inline-block;width:56px;height:28px;line-height:28px;text-align: center;font-size:13px;font-weight:normal;background:rgba(255, 255, 255, 1);color:rgba(158, 172, 196, 1);margin-right:20px;cursor:pointer;">查询</span>
                        </a-col>
                    </a-row>
                    <div class="account-table">
                        <a-table :data-source="numberData2" :pagination='false' :scroll="{ y: 240 }" :row-selection="{ selectedRowKeys: selectedRowKeys3, onChange: onSelectChange4 }" :rowKey="(record,index)=>{return record.id}">
                            <a-table-column key="number" title="号码" data-index="number">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.number}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="commodityName" title="商品名称" data-index="commodityName">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.commodityName}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="useCount" title="呼叫次数" data-index="useCount">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.useCount}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="allocateTime" title="分配时间" data-index="allocateTime">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.allocateTime}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="allocateCount" title="用户数量" data-index="allocateCount">
                                <template slot-scope="text, record">
                                    <span style="margin-right:8px">{{record.allocateCount}}</span>
                                </template>
                            </a-table-column>
                            <a-table-column key="id" title="操作" data-index="id">
                                <template slot-scope="text, record">
                                    <span style="color:rgba(58, 220, 255, 1);font-size:13px;text-decoration: underline;cursor: pointer;" @click="unbindNumber(record.id)">解绑</span>
                                </template>
                            </a-table-column>
                        </a-table>
                        <div style="height:40px;">
                            <a-select @change="changeDays" v-model="callTimes" style="width: 100%;width:150px;float:left;margin-top:8px;">
                                <a-select-option :value="1" key='1'>
                                    1天内
                                </a-select-option>
                                <a-select-option :value="7" key='7'>
                                    7天内
                                </a-select-option>
                                <a-select-option :value="30" key='30'>
                                    30天内
                                </a-select-option>
                                <a-select-option :value="60" key='60'>
                                    60天内
                                </a-select-option>
                                <a-select-option :value="90" key='90'>
                                    90天内
                                </a-select-option>
                                <a-select-option :value="180" key='180'>
                                    180天内
                                </a-select-option>
                                <a-select-option :value="360" key='360'>
                                    360天内
                                </a-select-option>
                            </a-select>
                            <div v-if="numberData2.length!=0" style="margin-top:12px;display:inline-block;">总计：{{numberData2.length}}个号码</div>
                        </div>
                    </div>
                    <div class="batch-operate" style="margin-top:16px;" v-if="this.selectedRowKeys3.length>0">
                        <span @click="batchUnbind" style="display:inline-block;width:64px;height:28px;line-height:28px;text-align:center;background:rgba(58, 220, 255, 1);color:#fff;font-size:13px;cursor:pointer;">批量解绑</span>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelNumberManage">取消</a-button>
                        <a-button type="primary" @click="sureNumberManage">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="batchUnbindModal" footer='' width='440px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>解绑</span>
                    <a-icon @click="cancelUnbind" type="close" />
                </div>
                <div class="modal-info">
                    <a-icon type="warning" />
                    <div class="modal-content">
                        <div class="modal-tip">你确定要解绑吗？</div>
                        <div class="modal-des">解绑后数据将无法恢复</div>
                    </div>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelUnbind">取消</a-button>
                    <a-button type="primary" @click="sureUnbind">确认</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props:{
        dataId: {
            default: ''
        },
        moduleId: {
            default: ''
        },
    },
    data(){
        return{
            operationAllBtnList: [
                {
                    name: '删除',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '停用',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '对账',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '实名',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '地址',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '中台超级登录',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '提交',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '协议',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '规格',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '结算价',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '余额充值',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '小文交互',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: 'EOCC',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '聚合短信',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '账单减免',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '账单附加',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '订单减免',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '订单生效',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '坏账',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '应付日期',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '号码',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '主叫号',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
            ],
            deleteModal: false,
            siteModal: false,
            addressInfo: {
                addressee: '',
                phone: '',
                area: '',
                detailAddress: '',
                isDefault: true
            },
            areasData: [],
            selectedAreaCode: [],
            selectedAreaStr: '',
            contractModal: false,
            headers: {
                authorization: 'authorization-text',
            },
            customerModal: false,
            providerModal: false,
            editingKey: '',
            newTagModal: false,
            currentTagId: '',
            tagListData: [],
            tagName: '',
            filterTagName: '',
            deleteTagModal: false,
            tagListBool: false,
            goodsSpecificationsModal: false,
            newGoodsModal: false,
            allDimensionListData: [],
            specificationsData: [
                {
                    id: '',
                    name: '',
                    sort: '',
                    unitPrice: '',
                    costPrice: '',
                    settlementPrice: '',
                    quantity: '',
                    discount: '',
                    orderAuthority: '',
                    status: '',
                }
            ],
            dimensionTypeList: [],
            specificationsAuthorityList: [],
            specificationsStatusList: [],
            newDimensionObj: {
                name: '',
                orderBy: '',
                type: '',
            },
            dimensionId: '',
            deleteDimensionModal: false,
            deleteSpecificationsModal: false,
            specificationsId: '',
            currentIndex: '',
            customerInfoData: '',
            settlementPriceList: [],
            priceId: '',
            changePriceModal: false,
            priceData: '',
            editSiteBool: false,
            siteListData: [],
            currentSiteId: '',
            deleteSiteModal: false,
            agreementListData: [],
            newAgreementState: false,
            agreementInfo: {
                id: '',
                status: undefined,
                // lowElimination: '',
                content: '',
                attachment: '',
            },
            newFormData2: '',
            deleteAgreementModal: false,
            currentAgreementId: '',
            deleteEnclosureModal: false,
            reducePriceModal: false,
            addReductionModal: false,
            payDateModal: false,
            changePayDateModal: false,
            extraBillModal: false,
            addExtraBillModal: false,
            badBillModal: false,
            addBadBillModal: false,
            reductionMoney: 0,
            reductionRemark: '',
            extraMoney: 0,
            extraRemark: '',
            badBillPrice: 0,
            badBillRemark: '',
            operationDate: null,
            timeRemark: '',
            reductionData: [],
            payData: [],
            attachmentData: [],
            badBillData: [],
            orderReductionModal: false,
            addOrderReductionModal: false,
            orderReductionMoney: '',
            orderReductionRemark: '',
            orderReductionData: [],
            effectiveModal: false,
            contractId: undefined,
            selectContractModal: false,
            contractSelectList: [],
            chargeModal: false,
            rechargeAmount: 0,
            toVoidModal: false,
            voidContent: '',
            reconciliationModal: false,
            numberManageModal: false,
            selectedRowKeys1: [],
            columns1: [
                {
                    dataIndex: 'id',
                    key: 'id',
                    title: 'id',
                    colSpan: 0,
                    customRender: () => {
                        return {
                            attrs: {
                                colSpan: 0,
                            },
                        };
                    },
                },
                {
                    dataIndex: 'number',
                    scopedSlots: {
                        customRender: 'number'
                    },
                    key: 'number',
                    title: '号码'
                },
                {
                    dataIndex: 'isShared',
                    scopedSlots: {
                        customRender: 'isShared'
                    },
                    key: 'isShared',
                    title: '权限'
                },
                {
                    dataIndex: 'status',
                    scopedSlots: {
                        customRender: 'status'
                    },
                    key: 'status',
                    title: '有效状态'
                },
            ],
            numberData1: [],
            newAddModal: false,
            normalModal: false,
            newFormData1: '',
            deleteModal2: false,
            currentKey: '',
            batchChangeModal: false,
            timer: null,
            searchId: '',
            searchNum: '',
            currentStatus: undefined,
            isShared: undefined,
            currentPage: 1,
            pageSize: 10,
            number1: '',
            status1: undefined,
            pageSizeOptions: ['10', '50 ','100', '200', '500', '1000'],
            selectedNumberId: '',
            total: 0,
            editNumberModal: false,
            number2: '',
            currentChangedId: '',
            editIsSharedModal: false,
            isShared2: undefined,
            editStatusModal: false,
            status2: undefined,
            numberRemark: '',
            editRemarkModal: false,
            editRemarkContent: '',
            remarkCondition: '',
            numberUser: '',
            middleUserName: '',
            middleUserModal: false,
            middleConditionName: '',
            selectedRowKeys2: [],
            middleUserList: [],
            timer2: null,
            authorityType: '',
            callNumberModal: false,
            allocateTime: null,
            numberKey: '',
            numberData2: [],
            selectedRowKeys3: [],
            batchUnbindModal: false,
            unbindNumberList: [],
            callTimes: 30,
        }
    },
    methods: {
        moment,
        selectBtn(name, active) {
            if(name == '删除'){
                this.deleteModal = true
            }else if(name == '地址'){
                this.siteModal = true
                this.editSiteBool = false
                this.addressInfo = {
                    addressee: '',
                    phone: '',
                    area: '',
                    detailAddress: '',
                    isDefault: true
                }
                this.querySiteList()
            }else if(name == '协议'){
                this.contractModal = true
                this.queryAgreementList()
            }else if(name == '停用'){
                this.voidContent = ''
                this.toVoidModal = true
            }else if(name == '对账'){
                this.reconciliationModal = true
            }else if(name == '实名'){
                this.customerModal = true
                this.queryCustomerInfo()
            }else if(name == '结算价'){
                this.providerModal = true
                this.queryPriceList()
            }else if(name == '规格'){
                this.goodsSpecificationsModal = true
                this.querySpecifications()
            }else if(name == '小文交互'){
                if(active){
                    this.$message.success('您已开通小文交互') 
                }else{
                    this.$message.error('您尚未开通小文交互')
                }
            }else if(name == 'EOCC'){
                if(active){
                    this.$message.success('您已开通EOCC') 
                }else{
                    this.$message.error('您尚未开通EOCC')
                }
            }else if(name == '聚合短信'){
                if(active){
                    this.$message.success('您已开通聚合短信') 
                }else{
                    this.$message.error('您尚未开通聚合短信')
                }
            }else if(name == '中台超级登录'){
                this.querySuperSite()
            }else if(name == '账单减免'){
                this.reductionPrice()
            }else if(name == '账单附加'){
                this.attachmentPrice()
            }else if(name == '坏账'){
                this.badBill()
            }else if(name == '应付日期'){
                this.payDate()
            }else if(name == '订单减免'){
                this.orderReduction()
            }else if(name == '订单生效'){
                this.orderEffection()
            }else if(name == '余额充值'){
                this.chargeModal = true
            }else if(name == '号码'){
                this.queryAccountData()
            }else if(name == '主叫号'){
                this.callNumberModal = true
                this.queryNumberList()
            }
        },
        cancelDelete() {
            this.deleteModal = false
        },
        sureDelete() {
            this.deleteModal = false
            this.axios.post('/api/module/data/delete', {
                moduleId: this.moduleId,
                dataId: this.dataId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$emit('closeAffairModel')
                    this.$message.success('删除成功')
                    this.$emit('queryParentBasicData')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryAreasData() {
            this.areasData = require('./../assets/area/areas.json')
        },
        changeArea(data1, data2) {
            this.selectedAreaCode = data1
            let str = ''
            for(let i = 0; i < data2.length; i++){
                str += data2[i]['label']
            }
            this.selectedAreaStr = str
        },
        cancelCustomer() {
            this.customerModal = false
        },
        sureCustomer() {
            this.customerModal = false
        },
        cancelProvider() {
            this.providerModal = false
        },
        sureProvider() {
            this.providerModal = false
        },
        edit(key) {
            const newData = [...this.data];
            const target = newData.find(item => key === item.key);
            this.editingKey = key;
            if (target) {
                target.editable = true;
                this.data = newData;
            }
        },
        judgeOperationBtn(param) {
            // console.log("参数")
            // console.log(param)
            this.operationAllBtnList = [
                {
                    name: '删除',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                // {
                //     name: '标签管理',
                //     icon: 'tags',
                //     ifShow: false,
                //     active: false,
                // },
                {
                    name: '停用',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '对账',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                }, 
                {
                    name: '实名',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '地址',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '中台超级登录',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '提交',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '协议',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '规格',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '结算价',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '余额充值',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '小文交互',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: 'EOCC',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '聚合短信',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '账单减免',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '账单附加',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '订单减免',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '订单生效',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '坏账',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '应付日期',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '号码',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
                {
                    name: '主叫号',
                    icon: 'tags',
                    ifShow: false,
                    active: false,
                },
            ]
            for(let i = 0; i < this.operationAllBtnList.length; i++){
                for(let j = 0; j < param.length; j++){
                    if(this.operationAllBtnList[i]['name'] == param[j] || (param[j].indexOf(this.operationAllBtnList[i]['name']) != -1)){
                        this.operationAllBtnList[i]['ifShow'] = true
                        if(param[j].split("-").length > 1){
                            if(param[j].split("-")[1]=='true'){
                                this.operationAllBtnList[i]['active'] = true
                            }else{
                                this.operationAllBtnList[i]['active'] = false
                            }
                        }
                    }
                }
            }
        },
        newTags() {
            this.newTagModal = true
            this.currentTagId = ''
        },
        queryTagList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/label/list', 
                    params: {
                        moduleId: this.moduleId,
                        name: this.filterTagName,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.tagListData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelNewTag() {
            this.newTagModal = false
            this.tagName = ''
        },
        sureNewTag() {
            this.newTagModal = false
            this.axios.post('/api/label', {
                moduleId: this.moduleId,
                id: this.currentTagId,
                name: this.tagName
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.tagName = ''
                    this.queryTagList()
                    this.$emit('queryTagList')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        ifDeleteTag(id) {
            this.deleteTagModal = true
            this.currentTagId = id
        },
        cancelDeleteTag() {
            this.deleteTagModal = false
        },
        sureDeleteTag() {
            this.deleteTagModal = false
            this.axios.delete('/api/label/'+this.currentTagId,{
                params: {
                    id: this.currentTagId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryTagList()
                    this.$emit('queryTagList')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        editTag(id, name) {
            this.currentTagId = id
            this.tagName = name
            this.newTagModal = true
        },
        cancelGoods() {
            this.goodsSpecificationsModal = false
        },
        sureGoods() {
            this.goodsSpecificationsModal = false
        },
        newSpecifications() {
            this.newGoodsModal = true
            this.dimensionId = ''
            this.newDimensionObj = {
                name: '',
                orderBy: '',
                type: '',
            },
            this.specificationsData = [
                {
                    id: '',
                    name: '',
                    sort: '',
                    unitPrice: '',
                    costPrice: '',
                    settlementPrice: '',
                    quantity: '',
                    discount: '',
                    orderAuthority: '',
                    status: '',
                }
            ]
        },
        cancelSpecifications() {
            this.newGoodsModal = false
        },
        sureSpecifications() {
            this.newGoodsModal = false
            this.axios.post('/api/commodity/saveDimension', {
                id: this.dimensionId,
                commodityId: this.dataId,
                type: this.newDimensionObj.type,
                name: this.newDimensionObj.name,
                sort: this.newDimensionObj.orderBy,
                specificationsList: this.specificationsData,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('新增成功')
                    this.newDimensionObj = {
                        name: '',
                        orderBy: '',
                        type: '',
                    },
                    this.specificationsData = [
                        {
                            id: '',
                            name: '',
                            sort: '',
                            unitPrice: '',
                            costPrice: '',
                            settlementPrice: '',
                            quantity: '',
                            discount: '',
                            orderAuthority: '',
                            status: '',
                        }
                    ]
                    this.querySpecifications()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        querySpecifications() {
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/queryAllDimensionList', 
                    params: {
                        commodityId: this.dataId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.allDimensionListData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        addItemList() {
            let obj = {
                id: '',
                name: '',
                sort: '',
                unitPrice: '',
                costPrice: '',
                settlementPrice: '',
                quantity: '',
                discount: '',
                orderAuthority: '',
                status: '',
            }
            this.specificationsData.push(obj)
        },
        queryDimensionType() {
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/dimensionTypeList', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.dimensionTypeList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryAuthorityType() {
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/specificationsAuthorityList', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.specificationsAuthorityList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryStatusType() {
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/specificationsStatusList', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.specificationsStatusList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        deleteDimension(id) {
            this.deleteDimensionModal = true
            this.dimensionId = id
        },
        cancelDeleteDimension() {
            this.deleteDimensionModal = false
        },
        sureDeleteDimension() {
            this.deleteDimensionModal = false
            this.axios.delete('/api/commodity/deleteDimension',{
                params: {
                    dimensionId: this.dimensionId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.querySpecifications()
                    this.dimensionId = ''
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        deleteSpecifications(index ,id) {
            if(id == ''){
                this.specificationsData.splice(index,1)
            }else{
                this.deleteSpecificationsModal = true
                this.specificationsId = id
                this.currentIndex = index
            }
        },
        editDimension(id) {
            this.newGoodsModal = true
            this.dimensionId = id
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/queryDimensionDetail', 
                    params: {
                        dimensionId: id,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.specificationsData = response.data.data.specificationsList
                    this.newDimensionObj = {
                        name: response.data.data.name,
                        orderBy: response.data.data.sort,
                        type: response.data.data.type,
                    }
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelDeleteSpecifications() {
            this.deleteSpecificationsModal = false
        },
        sureDeleteSpecifications() {
            this.deleteSpecificationsModal = false
            this.axios.delete('/api/commodity/deleteSpecifications',{
                params: {
                    specificationsId: this.specificationsId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.specificationsData.splice(this.currentIndex,1)
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        initData() {
            this.tagListBool = false
        },
        queryCustomerInfo() {
            this.axios(
                {
                    method:'get',
                    url:'/api/middlegroundUser/certification', 
                    params: {
                        middlegroundUserId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.customerInfoData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        changeExamineState(value) {
            this.axios.post('/api/middlegroundUser/updateCertificationStatus', {
                middlegroundUserId: this.dataId,
                status: value,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryPriceList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/commodity/settlementPriceList', 
                    params: {
                        providerId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.settlementPriceList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        showSettlementPriceModal(id, price) {
            this.priceId = id
            this.priceData = price
            this.changePriceModal = true
        },
        cancelChangePrice() {
            this.changePriceModal = false
        },
        sureChangePrice() {
            if(this.priceData > 0){
                this.changePriceModal = false
                this.axios.post('/api/commodity/updateSettlementPrice', {
                    serviceProviderId: this.dataId,
                    specificationsId: this.priceId,
                    settlementPrice: this.priceData
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryPriceList()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请输入结算金额大于0')
            }
            
        },
        querySuperSite() {
            this.axios(
                {
                    method:'get',
                    url:'/api/middlegroundUser/superLoginUrl', 
                    params: {
                        dataId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    window.open(response.data.data.superLoginUrl)
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        hideTagBox() {
            this.tagListBool = false
        },
        newSiteData() {
            this.editSiteBool = true
            this.currentSiteId = ''
            this.selectedAreaCode = []
            this.addressInfo = {
                addressee: '',
                phone: '',
                area: '',
                detailAddress: '',
                isDefault: true
            }
        },
        hideSiteData() {
            this.editSiteBool = false
            this.selectedAreaCode = []
            this.addressInfo = {
                addressee: '',
                phone: '',
                area: '',
                detailAddress: '',
                isDefault: true
            }
        },
        querySiteList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/middlegroundUser/receivingInformation/list', 
                    params: {
                        middlegroundUserId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.siteListData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        deleteSite(id) {
            this.deleteSiteModal = true
            this.currentSiteId = id
        },
        sureDeleteSite() {
            this.deleteSiteModal = false
            this.axios.delete('/api/middlegroundUser/receivingInformation/'+this.currentSiteId,{
                params: {
                    id: this.currentSiteId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.querySiteList()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelDeleteSite() {
            this.deleteSiteModal = false
        },
        cancelSite() {
            this.siteModal = false
        },
        sureSite() {
            if(this.editSiteBool){
                this.axios.post('/api/middlegroundUser/receivingInformation', {
                    id: this.currentSiteId,
                    middlegroundUserId: this.dataId,
                    addressee: this.addressInfo.addressee,
                    phone: this.addressInfo.phone,
                    area: this.selectedAreaCode,
                    areaName: this.selectedAreaStr,
                    detailAddress: this.addressInfo.detailAddress,
                    isDefault: this.addressInfo.isDefault
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.editSiteBool = false
                        this.querySiteList()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        editSite(id) {
            this.editSiteBool = true
            this.currentSiteId = id
            this.axios(
                {
                    method:'get',
                    url:'/api/middlegroundUser/receivingInformation', 
                    params: {
                        id: id,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.selectedAreaCode = response.data.data.area
                    this.addressInfo = {
                        addressee: response.data.data.addressee,
                        phone: response.data.data.phone,
                        area: response.data.data.area,
                        detailAddress: response.data.data.detailAddress,
                        isDefault: response.data.data.isDefault
                    }
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelContract() {
            this.contractModal = false
        },
        sureContract() {
            this.axios.post('/api/contract/saveAgreement', {
                id: this.agreementInfo.id,
                contractId: this.dataId,
                content: this.agreementInfo.content,
                // lowElimination: this.agreementInfo.lowElimination,
                status: this.agreementInfo.status,
                attachment: this.agreementInfo.attachment,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryAgreementList()
                    this.newAgreementState = false
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryAgreementList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/contract/agreementList', 
                    params: {
                        contractId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.agreementListData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        newAgreementOperate() {
            this.newAgreementState = true
            this.agreementInfo = {
                id: '',
                status: undefined,
                // lowElimination: '',
                content: '',
                attachment: '',
            }
        },
        customRequest2(data) {
            this.newFormData2 = ''
            const formData = new FormData() 
            formData.append('file', data.file)
            this.newFormData2 = formData
            this.axios({
                method: 'post',
                url: '/api/file/upload',
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded'
                },
                data: this.newFormData2,
            
            }).then((response) => {
                if(response.data.code == 0){
                    this.newFormData2 = ''
                    this.agreementInfo.attachment = response.data.data.fileId
                    this.$message.success('添加附件成功')
                }else{
                    this.$message.error(response.data.userTip)
                }
            }).catch(function (error) {
                console.log(error)
            })
        },
        deleteAttachment(id) {
            this.currentAgreementId = id
            this.deleteAgreementModal = true
        },
        downloadAttachment(url) {
            window.open(url)
        },
        cancelDeleteAgreement() {
            this.deleteAgreementModal = false
        },
        sureDeleteAgreement() {
            this.deleteAgreementModal = false
            this.axios.delete('/api/contract/agreement',{
                params: {
                    agreementId: this.currentAgreementId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.queryAgreementList()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        editAttachment(item) {
            this.newAgreementState = true
            this.agreementInfo = {
                id: item.id,
                status: item.status,
                // lowElimination: item.lowElimination,
                content: item.content,
                attachment: ''
            }
        },
        deleteEnclosureOperate(id) {
            this.currentAgreementId = id
            this.deleteEnclosureModal = true
        },
        cancelDeleteEnclosure() {
            this.deleteEnclosureModal = false
        },
        sureDeleteEnclosure() {
            this.deleteEnclosureModal = false
            this.axios.post('/api/contract/agreement/attachment', {
                agreementId: this.currentAgreementId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.queryAgreementList()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        reductionPrice() {
            this.reducePriceModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/dynamic/list', 
                    params: {
                        dataId: this.dataId,
                        type: 4
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.reductionData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelReducePrice() {
            this.reducePriceModal = false
        },
        sureReducePrice() {
            this.reducePriceModal = false
        },
        cancelAddReduction() {
            this.addReductionModal = false
        },
        sureAddReduction() {
            if(this.reductionMoney > 0 || this.reductionMoney == 0){
                this.addReductionModal = false
                this.axios.post('/api/bill/reduction', {
                    billId: this.dataId,
                    reductionMoney: this.reductionMoney,
                    remark: this.reductionRemark
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.reductionPrice()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请输入减免金额大于0')
            }
            
        },
        newReduction() {
            this.addReductionModal = true
            this.reductionMoney = 0
            this.reductionRemark = ''
        },

        orderReduction() {
            this.orderReductionModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/dynamic/list', 
                    params: {
                        dataId: this.dataId,
                        type: 2
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.orderReductionData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelOrderReduction() {
            this.orderReductionModal = false
        },
        sureOrderReduction() {
            this.orderReductionModal = false
        },
        cancelAddOrderReduction() {
            this.addOrderReductionModal = false
        },
        sureAddOrderReduction() {
            if(this.orderReductionMoney > 0 || this.orderReductionMoney == 0){
                this.addOrderReductionModal = false
                this.axios.post('/api/order/reduction', {
                    orderId: this.dataId,
                    reductionMoney: this.orderReductionMoney,
                    remark: this.orderReductionRemark
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.orderReduction()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请输入减免金额大于0')
            }
            
        },
        newOrderReduction() {
            this.addOrderReductionModal = true
            this.orderReductionMoney = 0
            this.orderReductionRemark = ''
        },

        payDate() {
            this.payDateModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/dynamic/list', 
                    params: {
                        dataId: this.dataId,
                        type: 6
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.payData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelPayDate() {
            this.payDateModal = false
        },
        surePayDate() {
            this.payDateModal = false
        },
        changePayDate() {
            this.changePayDateModal = true
            this.operationDate = null
        },
        cancelChangePayDate() {
            this.changePayDateModal = false
        },
        sureChangePayDate() {
            this.changePayDateModal = false
            this.axios.post('/api/bill/updatePayableTime', {
                billId: this.dataId,
                payableTime: this.operationDate==null?'':this.operationDate,
                remark: this.timeRemark
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.payDate()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        attachmentPrice() {
            this.extraBillModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/dynamic/list', 
                    params: {
                        dataId: this.dataId,
                        type: 3
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.attachmentData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelExtraBill() {
            this.extraBillModal = false
        },
        sureExtraBill() {
            this.extraBillModal = false
        },
        newExtraBill() {
            this.addExtraBillModal = true
        },
        cancelAddExtraBill() {
            this.addExtraBillModal = false
        },
        sureAddExtraBill() {
            if(this.extraMoney > 0 || this.extraMoney == 0){
                this.addExtraBillModal = false
                this.axios.post('/api/bill/additional', {
                    billId: this.dataId,
                    additionalMoney: this.extraMoney,
                    remark: this.extraRemark
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.attachmentPrice()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请输入附加金额大于0')
            } 
        },
        badBill() {
            this.badBillModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/dynamic/list', 
                    params: {
                        dataId: this.dataId,
                        type: 5
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.badBillData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelBadBill() {
            this.badBillModal = false
        },
        sureBadBill() {
            this.badBillModal = false
        },
        newBadBill() {
            this.addBadBillModal = true
        },
        cancelAddBadBill() {
            this.addBadBillModal = false
        },
        sureAddBadBill() {
            if(this.badBillPrice > 0){
                this.addBadBillModal = false
                this.axios.post('/api/bill/badDebt', {
                    billId: this.dataId,
                    badDebtMoney: this.badBillPrice,
                    remark: this.badBillRemark
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.badBill()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请输入坏账金额大于0')
            }
            
        },
        orderEffection() {
            this.axios(
                {
                    method:'get',
                    url:'/api/order/status', 
                    params: {
                        orderId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    if(response.data.data.effectiveStatus == 2){
                        this.$message.warning('该订单已生效')
                    }else if(response.data.data.effectiveStatus != 2&&response.data.data.status==1){
                        this.selectContractModal = true
                        this.contractId = undefined
                        this.queryContractList()
                    }else if(response.data.data.effectiveStatus != 2&&response.data.data.status==2){
                        this.effectiveModal = true
                    }
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelEffective() {
            this.effectiveModal = false
        },
        sureEffective() {
            this.effectiveModal = false
            this.contractId = ''
            this.effectiveOrder()
        },
        effectiveOrder() {
            this.axios.post('/api/order/effective', {
                orderId: this.dataId,
                contractId: this.contractId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('该订单已生效')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelSelectContract() {
            this.selectContractModal = false
        },
        sureSelectContract() {
            this.selectContractModal = false
            this.effectiveOrder()
        },
        queryContractList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/contract/contractSelectList', 
                    params: {
                        orderId: this.dataId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.contractSelectList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelCharge() {
            this.chargeModal = false
            this.rechargeAmount = 0
        },
        sureCharge() {
            if(this.rechargeAmount > 0){
                this.chargeModal = false
                this.axios.post('/api/account/recharge', {
                    middlegroundUserId: this.dataId,
                    rechargeAmount: this.rechargeAmount,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.rechargeAmount = 0
                        this.$emit('queryDetailsData')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('输入充值金额大于0')
            }
            
        },
        cancelVoid() {
            this.toVoidModal = false
        },
        sureVoid() {
            if(this.voidContent != ''){
                this.toVoidModal = false
                this.axios.post('/api/order/resource/cancel', {
                    id: this.dataId,
                    cancelReason: this.voidContent,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('该资源包已停用')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请填写备注')
            }
        },
        sureReconciliation() {
            this.reconciliationModal = false
            this.axios.post('/api/bill/reconciliation', {
                billId: this.dataId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelReconciliation() {
            this.reconciliationModal = false
        },
        cancelManageNumber() {
            this.numberManageModal = false
            this.selectedRowKeys1 = []
        },
        sureManageNumber() {
            this.numberManageModal = false
            this.isShared = undefined
            this.currentStatus = undefined
            this.searchNum = ''
        },
        onSelectChange2(selectedRowKeys) {
            this.selectedRowKeys1 = selectedRowKeys;
        },
        addSingle() {
            this.newAddModal = true
        },
        cancelAddList() {
            this.newAddModal = false
            this.number1 = ''
            this.status1 = undefined
        },
        sureAddList() {
            this.newAddModal = false
            this.axios.post('/api/number', {
                commodityId: this.dataId,
                number: this.number1,
                status: this.status1,
                remark: this.numberRemark
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('新增成功')
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        jurisdictionChange(value) {
            console.log(`selected ${value}`);
        },
        customRequest1(data) { // 上传提交
            this.newFormData1 = ''
            const formData = new FormData() 
            formData.append('file', data.file)
            formData.append('commodityId', this.dataId)
            this.newFormData1 = formData
        },
        onUpload() {
            this.$refs.pathClear.value = ''
        },
        cancelNormal() {
            this.normalModal = false
        },
        downloadTemplate() {
            window.open('/api/number/download/template', '_blank');
        },
        sureNormal() {
            this.normalModal = false
            this.axios({
                method: 'post',
                url: '/api/number/import/excel',
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded'
                },
                data: this.newFormData1,
            }).then((response) => {
                if(response.data.code == 0){
                    this.$message.success('导入成功')
                    this.queryAccountData()
                    this.newFormData1 = ''
                }else if(response.data.code == 'A0300'){
                    this.errorTipModal = true
                    this.errorInfo = JSON.parse(response.data.userTip)
                }else{
                    this.$message.error(response.data.userTip);
                }
            }).catch(function (error) {
                console.log(error)
            })
        },
        addBatch() {
            this.normalModal = true
        },
        cancelDeleteItem() {
            this.deleteModal2 = false
        },  
        sureDeleteItem() {
            this.deleteModal2 = false
            this.axios.delete('/api/number/'+this.selectedNumberId)
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('删除成功')
                    this.selectedNumberId = ''
                    this.currentPage = 1
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelBatchChange() {
            this.batchChangeModal = false
        },
        sureBatchChange() {
            this.batchChangeModal = false
        },
        queryAccountData() {
            this.numberManageModal = true
            this.axios(
                {
                    method:'get',
                    url:'/api/number/list', 
                    params: {
                        current: this.currentPage,
                        size: this.pageSize,
                        commodityId: this.dataId,
                        status: this.currentStatus,
                        number: this.searchNum,
                        remark: this.remarkCondition,
                        numberUser: this.numberUser
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    console.log(response.data.data)
                    this.numberManageModal = true
                    this.numberData1 = response.data.data.records
                    this.total = response.data.data.total
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        inputChange() {
            clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                this.currentPage = 1
                this.queryAccountData()
            },1500)
        },
        deleteSelectedNum(index) {
            this.selectedRowKeys1.splice(index, 1);
        },
        cleanSelected() {
            this.selectedRowKeys1 = []
        },
        deleteBatch(id) {
            this.deleteModal2 = true
            this.selectedNumberId = id
        },
        changeStatus(value) {
            this.currentStatus = value
            this.currentPage = 1
            this.queryAccountData()
        },
        onShowSizeChange(current, pageSize) {
            this.pageSize = pageSize;
            this.currentPage = current
            this.queryAccountData()
        },
        pageChange(current, pageSize) {
            this.currentPage = current
            this.pageSize = pageSize
            this.queryAccountData()
        },
        changeNumber(id, number) {
            this.editNumberModal = true
            this.currentChangedId = id
            this.number2 = number
        },
        changeIsShared(id, data) {
            this.editIsSharedModal = true
            this.currentChangedId = id
            if(data == '独享'){
                this.isShared2 = '0'
            }else if(data == '共享'){
                this.isShared2 = '1'
            }
        },
        changeListStatus(id, data) {
            this.editStatusModal = true
            this.currentChangedId = id
            if(data == '启用'){
                this.status2 = '1'
            }else if(data == '停用'){
                this.status2 = '2'
            }
        },
        cancelEditNumber() {
            this.editNumberModal = false
            this.number2 = ''
        },
        sureEditNumber() {
            this.editNumberModal = false
            this.axios.post('/api/number/updateNumber', {
                id: this.currentChangedId,
                number: this.number2,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelEditIsShared() {
            this.editIsSharedModal = false
            this.isShared2 = undefined
        },
        sureEditIsShared() {
            this.editIsSharedModal = false
            this.axios.post('/api/number/updateIsShared', {
                id: this.currentChangedId,
                isShared: this.isShared2,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        cancelEditStatus() {
            this.editStatusModal = false
            this.status2 = undefined
        },
        sureEditStatus() {
            this.editStatusModal = false
            this.axios.post('/api/number/updateStatus', {
                id: this.currentChangedId,
                status: this.status2,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        changeRemark(id, data) {
            this.editRemarkContent = data
            this.currentChangedId = id
            this.editRemarkModal = true
        },
        cancelEditRemark() {
            this.editRemarkModal = false
        },
        sureEditRemark() {
            this.editRemarkModal = false
            this.axios.post('api/number/updateRemark', {
                id: this.currentChangedId,
                remark: this.editRemarkContent,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('修改成功')
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        batchAddAuthority() {
            this.authorityType = 'add'
            if(this.selectedRowKeys1.length == 0){
                this.$message.error('请先选择号码')
            }else{
                this.middleUserModal = true
                this.queryMiddleUser()
            }
        },
        batchReduceAuthority() {
            this.authorityType = 'reduce'
            if(this.selectedRowKeys1.length == 0){
                this.$message.error('请先选择号码')
            }else{
                this.middleUserModal = true
                this.queryMiddleUser()
            }
        },
        queryMiddleUser() {
            this.axios(
                {
                    method:'get',
                    url:'/api/number/middlegroundUserList', 
                    params: {
                        name: this.middleUserName,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.selectedRowKeys2 = []
                    this.middleUserList = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        cancelMiddleUser() {
            this.selectedRowKeys2 = []
            this.middleUserModal = false
        },
        sureMiddleUser() {
            this.middleUserModal = false
            if(this.selectedRowKeys2.length == 0){
                this.$message.error('请选择用户')
                return
            }
            let url = ''
            if(this.authorityType == 'add'){
                url = '/api/number/addUser'
            }else{
                url = '/api/number/removeUser'
            }
            this.axios.post(url, {
                numberIdList: this.selectedRowKeys1,
                userIdList: this.selectedRowKeys2,
            })
            .then(response=> {
                if(response.data.code == 0){
                    if(this.authorityType == 'add'){
                        this.$message.success('新增成功')
                    }else{
                        this.$message.success('删除成功')
                    }
                    this.selectedRowKeys1 = []
                    this.queryAccountData()
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        inputMiddleChange() {
            clearTimeout(this.timer2)
            this.timer2 = setTimeout(()=>{
                this.queryMiddleUser()
            },1500)
        },
        onSelectChange3(selectedRowKeys) {
            this.selectedRowKeys2 = selectedRowKeys;
        },
        cancelCallNumber() {
           this.callNumberModal = false 
        },
        onSelectChange4(selectedRowKeys) {
            this.selectedRowKeys3 = selectedRowKeys;
        },
        unbindNumber(id) {
            this.unbindNumberList = []
            this.unbindNumberList.push(id)
            this.callNumberModal = false
            this.batchUnbindModal = true
        },
        cancelNumberManage() {
            this.callNumberModal = false 
        },
        sureNumberManage() {
            this.callNumberModal = false 
        },
        cancelUnbind() {
            this.batchUnbindModal = false
        },
        sureUnbind() {
            this.batchUnbindModal = false
            this.axios.post('/api/number/manage/unbind', 
            {
                numberIdList: this.unbindNumberList,
                userId: this.dataId,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('已解绑')
                    this.unbindNumberList = []
                    this.numberData2 = []
                    this.numberKey = ''
                    this.allocateTime = null
                    this.selectedRowKeys3 = []
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryNumberList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/number/manage/userNumberList', 
                    params: {
                        userId: this.dataId,
                        number: this.numberKey,
                        allocateTimeQ: this.allocateTime!=null?this.allocateTime[0]:'',
                        allocateTimeZ: this.allocateTime!=null?this.allocateTime[1]:'',
                        days: this.callTimes
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.numberData2 = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        batchUnbind() {
            this.unbindNumberList = []
            this.unbindNumberList = this.selectedRowKeys3
            this.callNumberModal = false
            this.batchUnbindModal = true
        },
        goLink() {
            let pathHerf = this.$router.resolve({
                path:'/NumberExternalLink', // 你自己要跳转的路径
                query:{
                    id: this.dataId  // query 要传递携带的参数，如：当前传递的是所需id
                }
            })
            window.open(pathHerf.href, '_blank');
        },
        changeDays() {
            this.queryNumberList()
        }
    },
    mounted: function() {
        this.queryAreasData()
        this.queryDimensionType()
        this.queryAuthorityType()
        this.queryStatusType()
    }
}
</script>
<style scoped lang="less">
    .operation-btn{
        width: 52px;
        display: inline-block;
        height: 690px;
        text-align: center;
        position: relative;
        .operation-btn-list{
            div{
                cursor: pointer;
                margin-top: 12px;
                padding: 8px 0;
                color: rgba(158, 172, 196, 1);
                font-size: 12px;
            }
            i{
                color: rgba(158, 172, 196, 0.7);
                font-size: 18px;
            }
            span{
                display: block;
            }
            div:hover{
                background: rgba(158, 172, 196, 0.12);
            }
        }
        .active{
            i{
                color: rgba(58, 220, 255, 1);
                font-size: 18px;
            }
            div{
                color: rgba(58, 220, 255, 1);
                font-size: 12px;
            }
        }
    }
    .tag-box{
        // position: absolute;
        // right: 55px;
        // top: 50px;
        z-index: 1000;
        background: #fff;
        padding-top: 12px;
        // width: 240px;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
        height: 300px;
        .new-add-tags{
            height: 48px;
            position: relative;
            .coordination-search-button{
                float: right;
                height: 28px;
                line-height: 28px;
                background: rgba(158, 172, 196, 0.12);
                color: rgba(158, 172, 196, 1);
                margin-right: 20px;
                text-align: center;
                border: none;
            }
            .coordination-search-close{
                position: absolute;
                right: 5px;
                top: 0px;
                cursor: pointer;
                color: #9eacc4;
            }
        }
        .coordination-search{
            position: relative;
            padding: 0 20px;
            .coordination-search-icon{
                position: absolute;
                top: 9px;
                left: 30px;
                z-index: 10;
                color: rgba(158, 172, 196, 0.7);
            }
            .coordination-search-input{
                width: 100%;
                height: 32px;
                padding-left: 30px;
            }
        }
        .tag-list{
            height: 200px;
            overflow-y: auto;
            padding: 0 20px;
            li{
                height: 44px;
                line-height: 44px;
                cursor: pointer;
                padding-left: 16px;
                padding-right: 8px;
                text-align: left;
                .tag-icon{
                    font-size: 16px;
                }
                .tag-name{
                    font-size: 13px;
                    margin-left: 8px;
                }
                div{
                    float: right;
                    display: none;
                    i{
                        color: rgba(158, 172, 196, 0.7);
                        font-size: 12px;
                    }
                    i:nth-child(1){
                        margin-right: 8px;
                    }
                }
            }
            li:hover{
                background: rgba(240, 242, 243, 0.5);
                div{
                    display: inline-block;
                }
            }
        }
    }
    .modal-public{
        .modal-title{
            height: 55px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding: 20px 20px 0 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                color: rgba(158, 172, 196, 1);
                float: right;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .modal-info{
            padding: 16px 20px 24px 24px;
            .modal-content{
                flex: 1;
                margin-left: 20px;
                .modal-tip{
                    color: rgba(18, 18, 18, 1);
                    font-size: 16px;
                }
                .modal-des{
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                    margin-top: 12px;
                }
            }
        }
        .btn-group{
            text-align: right;
            padding: 0 20px 20px 0;
            button{
                width: 64px;
                height: 28px;
                font-size: 13px;
                text-align: center;
            }
            button:nth-child(1){
                margin-right: 8px;
                color: rgba(158, 172, 196, 1);
                border: none;
            }
            button:nth-child(2){
                color: #fff;
                background: rgba(58, 220, 255, 1);
            }
        }
    }
    .delete-modal{
        .modal-info{
            display: flex;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
        }
    }
    .site-modal{
        .modal-info{
            height: 550px;
            .site-list{
                flex:1;
                overflow-y: auto;
                border-top: 1px solid rgba(229, 229, 229, 1);
                li{
                    height: 58px;
                    padding: 21px 0 17px 0;
                    border-bottom: 1px solid rgba(229, 229, 229, 1);
                    .name{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                        display: inline-block;
                        width: 130px;
                    }
                    .phone{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                        display: inline-block;
                        width: 130px;
                    }
                    .site{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                        display: inline-block;
                        width: 480px;
                    }
                    .default-site{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                        display: inline-block;
                        width: 145px;
                    }
                    .edit-btn{
                        color: rgba(158, 172, 196, 1);
                        font-size: 14px;
                        display: none;
                        i{
                            cursor: pointer;
                        }
                        i:nth-child(1){
                            margin-right: 16px;
                        }
                    }
                }
                li:hover{
                    .edit-btn{
                        display: inline-block;
                    }
                }
            }
        }
        .btn-group{
            padding-top: 16px;
            border-top: 1px solid rgba(229, 229, 229, 1);
        }
    }
    .contract-modal{
        .modal-info{
            height: 550px;
            .contract-list{
                padding: 19px 0;
                border-bottom: 1px solid rgba(229, 229, 229, 1);
                .date{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                    margin-right: 50px;
                }
                .state{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                    margin-right: 74px;
                }
                .money{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
                .edit-btn{
                    display: none;
                    float: right;
                    i{
                        color: rgba(158, 172, 196, 1);
                        font-size: 14px;
                        cursor: pointer;
                    }
                    i:nth-child(1){
                        margin-right: 16px;
                    }
                }
                .des{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                    margin-top: 15px;
                }
                .enclosure{
                    display: inline-block;
                    width: 466px;
                    height: 32px;
                    background: rgba(158, 172, 196, 0.12);
                    padding: 4px 12px 0 8px;
                    margin-top: 16px;
                    .file-icon{
                        color: rgba(24, 144, 255, 1);
                        font-size: 16px;
                    }
                    .name{
                        color: rgba(18, 18, 18, 1);
                        font-size: 12px;
                        margin-left: 8px;
                    }
                    .enclosure-btn{
                        float: right;
                        margin-top: 3px;
                        display: none;
                        i{
                            color: rgba(158, 172, 196, 1);
                            font-size: 14px; 
                            cursor: pointer;
                        }
                        i:nth-child(1){
                            margin-right: 12px;
                        }
                    }
                }
                .enclosure:hover{
                    .enclosure-btn{
                        display: inline-block;
                    }
                }
            }
            .contract-list:hover{
                .edit-btn{
                    display: inline-block;
                }
            }
        }
    }
    .customer-modal{
        .modal-info{
            height: 550px;
            .customer-list{
                padding: 12px 0;
                .list-item{
                    span:nth-child(1){
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        width: 99px;
                        display: inline-block;
                    }
                    span:nth-child(2){
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                        display: inline-block;
                    }
                    img{
                        width: 240px;
                        height: 135px;
                    }
                }
            }
        }
        .btn-group{
            padding-top: 16px;
            border-top: 1px solid rgba(229, 229, 229, 1);
        }
    }
    .provider-modal{
        .modal-info{
            height: 550px;
        }
        .btn-group{
            padding-top: 16px;
            border-top: 1px solid rgba(229, 229, 229, 1);
        }
    }
    .editable-row-operations a {
        margin-right: 8px;
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 0 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .goods-specificationsModal-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .new-specificationsModal{
            height: 71px;
            padding: 19px 23px 0 0;
            button{
                float: right;
                background: rgba(158, 172, 196, 0.12);
                font-size: 13px;
                color: rgba(158, 172, 196, 1);
                border: none;
            }
        }
        .dimension-box{
            padding: 0 24px;
            max-height: 400px;
            overflow-y: auto;
            .dimension-list{
                margin-bottom: 26px;
                .dimension-row{
                    margin-bottom: 16px;
                    span{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                    }
                    i{
                        color: rgba(158, 172, 196, 1);
                        font-size: 14px;
                        cursor: pointer;
                        margin-left: 16px;
                        float: right;
                        display: none;
                    }
                }
                .dimension-content{
                    border: 1px solid rgba(232, 235, 238, 1);
                }
                .dimension-head{
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: rgba(232, 235, 238, 1);
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
                .dimension-body{
                    // height: 44px;
                    // line-height: 44px;
                    color: rgba(18, 18, 18, 1);
                    padding: 10px 0 0 0;
                    font-size: 13px;
                    text-align: center;
                }
            }
            .dimension-list:hover{
                i{
                   display: block; 
                }
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .new-goods-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .dimension-box{
            padding: 0 24px;
            max-height: 400px;
            overflow-y: auto;
            margin-top: 16px;
            .dimension-list{
                margin-bottom: 16px;
                .dimension-row{
                    margin-bottom: 26px;
                    .dimension-name{
                        width: 164px;
                    }
                    span{
                        color: rgba(18, 18, 18, 1);
                        font-size: 13px;
                    }
                    i{
                        color: rgba(158, 172, 196, 1);
                        font-size: 14px;
                        cursor: pointer;
                        margin-left: 16px;
                        float: right;
                        display: none;
                    }
                }
                .specifications-box{
                    border-bottom: 1px solid rgba(232, 235, 238, 1);
                    .specifications-head{
                        background: rgba(232, 235, 238, 1);
                        height: 44px;
                        line-height: 44px;
                        text-align: left;
                        padding-left: 10px;
                        font-size: 13px;
                        color: rgba(18, 18, 18, 1);
                    }
                    .specifications-list{
                        .specifications-name{
                            width: 90%;
                        }
                        padding-left: 10px;
                        height: 44px;
                        padding-top: 5px;
                        .specifications-col-3{
                            width: 90px;
                        }
                        .specifications-col-2{
                            width: 60px;
                        }
                    }
                    .add-item-list{
                        height: 50px;
                        margin: 12px 0;
                        button{
                            float: right;
                        }
                    }
                }
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .bill-reduction-modal{
        .reduction-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .reduction-data{
            // height: 150px;
            padding: 19px 24px 29px 24px;
            .new-reduction{
                margin-bottom: 16px;
                text-align: right;
                button{
                    height: 28px;
                    background: rgba(158, 172, 196, 0.12);
                    color: rgba(158, 172, 196, 1);
                    border: none;
                    font-weight: 150;
                    font-size: 13px;
                }
            }
        }
        .btn-group{
            padding: 16px 20px 0 0;
            height: 58px;
            border-top: 1px solid rgba(229, 229, 229, 1);
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .add-reduction-modal{
        .reduction-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .reduction-data{
            // height: 130px;
            padding: 19px 24px 29px 24px;
            .reduction-item{
                display: flex;
                margin-bottom: 13px;
                .date-reduction{
                    width: 200px;
                }
                .reduction-input{
                    flex: 1;
                }
                span{
                    display: inline-block;
                    width: 70px;
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                    float: left;
                    margin-top: 5px;
                }
                textarea{
                    resize: none;
                }
            }
            
        }
        .btn-group{
            padding: 16px 20px 0 0;
            height: 58px;
            border-top: 1px solid rgba(229, 229, 229, 1);
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .number-manage-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .number-manage-data{
            padding: 24px;
            .input-add-btn{
                text-align: right;
                button{
                    background: rgba(158, 172, 196, 0.12);
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                    height: 28px;
                    margin-left: 12px;
                    border: none;
                }
            }
            .filter-condition{
                margin: 24px 0;
                span{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
                input{
                    width: 240px;
                }
            }
            .account-right-content{
                padding-left: 24px;
                .choosed-title{
                    span:nth-child(1){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                    span:nth-child(2){
                        color: rgba(58, 220, 255, 1);
                        font-size: 14px;
                        float: right;
                        cursor: pointer;
                    }
                }
                .choosed-content{
                    margin-top: 24px;
                    .choosed-item{
                        display: inline-block;
                        width: 132px;
                        height: 32px;
                        margin: 0 8px 8px 0;
                        background: rgba(121, 136, 155, 0.1);
                        text-align: center;
                        line-height: 32px;
                        padding: 0 8px;
                        .choosed-phone{
                            color: rgba(121, 136, 155, 1);
                            font-size: 16px;
                            float: left;
                            margin-top: 7px;
                        }
                        .choosed-number{
                            color: rgba(80, 80, 80, 1);
                            font-size: 14px;
                            display: inline-block;
                            width: 84px;
                            overflow: hidden;
                        }
                        .choosed-close{
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                            float: right;
                            margin-top: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .batch-operate{
                margin-top: 24px;
                button{
                    margin-right: 12px;
                    color: #fff;
                    font-size: 13px;
                    background: rgba(58, 220, 255, 1);
                }
            }
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .new-add-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data-list{
            padding: 24px;
            .input-add-btn{
                text-align: right;
                button{
                    background: rgba(158, 172, 196, 0.12);
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                    height: 28px;
                    margin-left: 12px;
                    border: none;
                }
            }
            
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .normal-modal{
        padding-bottom: 46px;
        .tab-normal{
            height: 330px;
            padding: 0 24px;
        }
    }
</style>